import { useState } from 'react';

export function useFileHubPartyPicker() {
  const [partyPickerOpen, setPartyPickerOpen] = useState(false);
  const [partyPickerTarget, setPartyPickerTarget] = useState('main');
  const [partyRoleDraft, setPartyRoleDraft] = useState('Autor');

  return {
    partyPickerOpen, setPartyPickerOpen,
    partyPickerTarget, setPartyPickerTarget,
    partyRoleDraft, setPartyRoleDraft,
  };
}
